<div class="row justify-content-center pb-2 timebar-main">
  <div class="col-12 ">
    <div class="row timebar py-2 px-2">
      <div class="col-auto">
        <strong class="mb-0">{{ date }}</strong>
      </div>
      <div class="col-auto ml-auto">
        <p class="mb-0">{{ title }}</p>
      </div>
    </div>
  </div>
</div>
